import styles from './ActionCard.module.scss'
import { ActionCardProps } from 'pages/app/referral/components/action-card/types'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { Button, Drawer, Heading, Tag, TextAndMedia } from '@boltenergy-be/design-system'
import { DAYJS_THRESHOLDS } from 'constants/referral.ts'
import DurationTimestamp from 'components/duration-timestamp/DurationTimestamp.tsx'
import { BlocksRenderer } from '@strapi/blocks-react-renderer'
import { useState } from 'react'

dayjs.extend(relativeTime, {
  thresholds: DAYJS_THRESHOLDS,
  rounding: Math.floor
})

const ActionCard = ({ activeAction }: ActionCardProps) => {
  // i18n
  const { t } = useTranslation('referral')

  // Local state
  const [openDrawer, setOpenDrawer] = useState<boolean>(false)

  return (
    <>
      <TextAndMedia
        fluid
        inverse
        inset
        color="accent-vibrant"
        aboveTitleSlot={
          <Tag type="positive" icon="clock">
            <DurationTimestamp endDate={activeAction.end} />
          </Tag>
        }
        title={activeAction.shortContent.title}
        titleVariant="h3"
        classnames={{ container: styles.action, content: styles.content }}
        showMediaOnMobile
        media={
          activeAction?.video
            ? {
                type: 'video',
                imageBehaviour: 'stretch',
                props: {
                  publicId: activeAction.video.provider_metadata.public_id,
                  thumbnail: {
                    publicId: activeAction.image.provider_metadata.public_id,
                    alt: '',
                    fill: true,
                    style: { aspectRatio: '4/3' }
                  }
                }
              }
            : {
                type: 'image',
                imageBehaviour: 'stretch',
                props: {
                  publicId: activeAction.image.provider_metadata.public_id,
                  alt: '',
                  fill: true
                }
              }
        }
      >
        <div className={styles.description}>
          <BlocksRenderer content={activeAction.shortContent.description} />

          <Button representation="link" variant="inline" onClick={() => setOpenDrawer(true)}>
            {t(($) => $.activeAction.moreInfo)}
          </Button>
        </div>
      </TextAndMedia>

      {!!activeAction && (
        <Drawer isOpen={openDrawer} onRequestClose={() => setOpenDrawer(false)} title={activeAction.conditions.title}>
          <div className={styles['drawer-content']}>
            <BlocksRenderer
              content={activeAction.conditions.description}
              blocks={{
                heading: ({ children, level }) => (
                  <Heading as={`h${level}`} variant={level === 1 ? 'h2' : 'h6'}>
                    {children}
                  </Heading>
                )
              }}
            />
          </div>
        </Drawer>
      )}
    </>
  )
}

export default ActionCard
